import { Modal } from "flowbite-react";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import FormCreateIndicator from "../forms/FormCreateIndicator";
import { createIndicator } from "../../services/indicator.api";


type Props = {
  onClosed: () => void;
  onSave: (indicatorId: string) => void;
}

export default function ModalCreateIndicator(props: Props) {
  const { notifySuccess, notifyError } = useToastContext();

  const handleCloseModal = () => { props.onClosed && props.onClosed() }

  async function handleSubmit(dataToSave) {
    try {
      const result = await createIndicator(dataToSave);

      const { ok, data } = result;
      if (ok && data) {
        props.onSave((data as { _id: string })?._id);
        notifySuccess(`Indicador"${(data as { name: string })?.name}" criado com sucesso!`);
      }
      if (!result.ok) {
        notifyError(result.message as string)
      }
    } catch (err) {
      console.error(err);
      notifyError("Erro ao tentar salvar indicador, tente novamente")
      return {
        ok: false,
        data: dataToSave,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any).message, path: [] }]
      }
    }
  }

  return (
    <Modal
      className="relative"
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className="text-black"><h2 className="text-black">{'Novo Embaixador'}</h2></Modal.Header>
      <Modal.Body className="dark:text-black">
        <FormCreateIndicator onSubmit={handleSubmit} />
      </Modal.Body>
    </Modal>
  );
}